import * as types from '@/store/mutations'
import api from '@/services/kickbacklog.js'

const getters = {
  kickbacklog: (state)=> state.kickbacklog,
}

const actions = {
  loadAllKickbacklogs({ commit }) {
    return new Promise((resolve, reject) => {
      api.getAllKickbacklogs().then((res)=>{
        commit(types.SET_ALL_KICKBACKLOG,res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  }
}

const mutations = {
  [types.SET_ALL_KICKBACKLOG](state, kickbacklog) {
    state.kickbacklog = kickbacklog
  }
}

const state = {
  kickbacklog: [],
}

export default {
  state,
  getters,
  actions,
  mutations
}
